// Admin routes: users, settings, companies, audit, security, governance, system tools
import Users from '../pages/Users';
import Settings from '../pages/Settings';
import Backup from '../pages/Backup';
import SystemReset from '../pages/SystemReset';
import CompanyProfile from '../pages/CompanyProfile';
import Companies from '../pages/Companies';
import MigrationCenter from '../pages/MigrationCenter';
import HealthMonitor from '../pages/HealthMonitor';
import Hardening from '../pages/Hardening';
import I18nHealth from '../pages/I18nHealth';
import SystemHealthDashboard from '../pages/SystemHealthDashboard';
import LowMemoryStatus from '../pages/LowMemoryStatus';
import ArchiveCenter from '../pages/ArchiveCenter';
import LegacyRecoveryCenter from '../pages/LegacyRecoveryCenter';
import AuditTrailVisualizer from '../pages/AuditTrailVisualizer';
import AuditLog from '../pages/AuditLog';
import AuditIntelligence from '../pages/AuditIntelligence';
import DataIntegrity from '../pages/DataIntegrity';
import SecuritySessions from '../pages/SecuritySessions';
import SecurityDashboard from '../pages/SecurityDashboard';
import Governance from '../pages/Governance';
import ApprovalMatrixSettings from '../pages/ApprovalMatrixSettings';
import ExpenseCategoryMappings from '../pages/ExpenseCategoryMappings';
import AutopostInsights from '../pages/AutopostInsights';
import PeriodReopenCenter from '../pages/PeriodReopenCenter';
import CompanyOnboarding from '../pages/onboarding/CompanyOnboarding';
import ExternalAccountantWorkspace from '../pages/ExternalAccountantWorkspace';
import AccountantTaxAdjustments from '../pages/AccountantTaxAdjustments';
import StorageHealth from '../pages/StorageHealth';
import OwnerControls from '../pages/OwnerControls';

const adminRoutes = [
  { path: '/users', Component: Users },
  { path: '/settings', Component: Settings },
  { path: '/owner-controls', Component: OwnerControls },
  { path: '/backup', Component: Backup },
  { path: '/system-reset', Component: SystemReset },
  { path: '/company-profile', Component: CompanyProfile },
  { path: '/companies', Component: Companies },
  { path: '/migration-center', Component: MigrationCenter },
  { path: '/health-monitor', Component: HealthMonitor },
  { path: '/hardening', Component: Hardening },
  { path: '/i18n-health', Component: I18nHealth },
  { path: '/system-health', Component: SystemHealthDashboard, withUser: true },
  { path: '/low-memory-mode', Component: LowMemoryStatus, withUser: true },
  { path: '/archive-center', Component: ArchiveCenter, withUser: true },
  { path: '/legacy-audit', Component: LegacyRecoveryCenter, withUser: true },
  { path: '/audit-trail', Component: AuditTrailVisualizer },
  { path: '/audit-log', Component: AuditLog },
  { path: '/audit-intelligence', Component: AuditIntelligence, withUser: true },
  { path: '/data-integrity', Component: DataIntegrity, withUser: true },
  { path: '/security', Component: SecuritySessions, withUser: true },
  { path: '/security-dashboard', Component: SecurityDashboard },
  { path: '/governance', Component: Governance, withUser: true },
  { path: '/approval-matrix', Component: ApprovalMatrixSettings, withUser: true },
  { path: '/expense-category-mappings', Component: ExpenseCategoryMappings, withUser: true },
  { path: '/autopost-insights', Component: AutopostInsights, withUser: true },
  { path: '/period-reopen', Component: PeriodReopenCenter, withUser: true },
  { path: '/onboarding', Component: CompanyOnboarding },
  { path: '/external-accountant', Component: ExternalAccountantWorkspace },
  { path: '/external-accountant/tax-adjustments', Component: AccountantTaxAdjustments },
  { path: '/storage-health', Component: StorageHealth },
];

export default adminRoutes;
